import { applyCustomColors } from "./customHighchartBlueColor";
import renderChart from "./renderChart";

export const pieChartConfig = (data, options) => {
  const dataset = Object.keys(data).map(key => ({
    name: key,
    y: data[key]
  }));

  // Apply custom colors if provided, otherwise use the default Highcharts colors
  const customColors = applyCustomColors(options.color);
  // Position value labels 30% inside the pie slice.
  const PIE_VALUE_LABEL_DISTANCE = "-30%";

  return {
    chart: {
      type: "pie"
    },
    title: {
      text: null
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      pie: {
        dataLabels: [
          {
            enabled: true,
            format: "{point.name}: {point.percentage:.1f} %"
          },
          {
            distance: PIE_VALUE_LABEL_DISTANCE,
            enabled: options.showValues,
            format: "{point.y}",
            style: {
              color: "contrast"
            }
          }
        ]
      }
    },
    series: [
      {
        name: options.label,
        data: dataset
      }
    ],
    colors: customColors
  };
};

const pieChart = (element, data, options) => {
  return renderChart(element, pieChartConfig(data, options), options);
};

export default pieChart;
